import { handleApi } from "../common";

const API_CONSTANTS = {
  updateFoDisclosure: "/api/equity/audit/fno",
};

export const update_fo_disclosure = async ({ Api, body = {}, token }) => {
  const url = API_CONSTANTS.updateFoDisclosure;
  const response = await Api.post(url, body, {}, token);
  const result = handleApi(response);
  return result;
};
